import { useTranslation } from 'react-i18next';
import { S, StatusBadge, formatCurrency } from '../regureStyles';
import { useFeature } from '../../hooks/useAccess';

const Table = ({ filtered, setSelected }) => {
  const { t } = useTranslation();
  // The Bordereaux COLUMN goes with the tab and the card: a tenant without the
  // module should not see a column of "Pending" badges for reports it cannot
  // generate. Header and cell are gated together so they cannot fall out of
  // step and shift every row's columns.
  const bordereauxEnabled = useFeature('bordereaux');
  const headers = [
    t('screens.riskCarriers.colCarrier',        { defaultValue: 'Carrier' }),
    t('screens.riskCarriers.colCode',           { defaultValue: 'Code' }),
    t('screens.riskCarriers.colProducts',       { defaultValue: 'Products' }),
    t('screens.riskCarriers.colActivePolicies', { defaultValue: 'Active Policies' }),
    t('screens.riskCarriers.colMonthlyPremium', { defaultValue: 'Monthly Premium' }),
    ...(bordereauxEnabled ? [t('screens.riskCarriers.colBordereaux', { defaultValue: 'Bordereaux' })] : []),
    t('screens.riskCarriers.colStatus',         { defaultValue: 'Status' }),
  ];
  const bordereauLabel = (v) => {
    if (v === 'Generated') return t('screens.riskCarriers.bordereauGenerated', { defaultValue: 'Generated' });
    return t('screens.riskCarriers.bordereauPending', { defaultValue: 'Pending' });
  };
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          {headers.map(h => (
            <th
              key={h}
              style={{
                padding: '13px 14px',
                textAlign: 'left',
                fontSize: 11,
                fontWeight: 700,
                color: S.textMuted,
                textTransform: 'uppercase',
                letterSpacing: 0.8,
                borderBottom: `2px solid ${S.borderLight}`,
                whiteSpace: 'nowrap',
              }}
            >
              {h}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {filtered.map((c, i) => (
          <tr
            key={c.id}
            onClick={() => setSelected(c)}
            style={{ borderBottom: `1px solid ${S.borderLight}`, cursor: 'pointer', background: i % 2 === 0 ? '#fff' : S.bgCard, transition: 'background 0.12s' }}
            onMouseEnter={e => (e.currentTarget.style.background = S.bgHover)}
            onMouseLeave={e => (e.currentTarget.style.background = i % 2 === 0 ? '#fff' : S.bgCard)}
          >
            <td style={{ padding: '13px 14px' }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: S.textPrimary }}>{c.name}</div>
              <div style={{ fontSize: 12, color: S.textMuted }}>{[c.city, c.canton].filter(Boolean).join(', ') || '—'}</div>
            </td>
            <td style={{ padding: '13px 14px', fontSize: 12, fontWeight: 700, color: S.textMuted, fontFamily: 'monospace' }}>{c.code || '—'}</td>
            <td style={{ padding: '13px 14px' }}>
              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                {(c.products || []).slice(0, 2).map(p => (
                  <span key={p} style={{ padding: '2px 8px', background: `rgba(128,0,32,0.07)`, color: S.burgundy, borderRadius: 4, fontSize: 11, fontWeight: 600 }}>
                    {p.split(' ')[0]}
                  </span>
                ))}
                {c.products?.length > 2 && <span style={{ fontSize: 11, color: S.textMuted }}>+{c.products.length - 2}</span>}
              </div>
            </td>
            <td style={{ padding: '13px 14px', fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{c.activePolicies}</td>
            <td style={{ padding: '13px 14px', fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{formatCurrency(c.monthlyPremium)}</td>
            {bordereauxEnabled && (
              <td style={{ padding: '13px 14px' }}>
                <span
                  style={{
                    padding: '4px 10px',
                    borderRadius: 6,
                    fontSize: 11,
                    fontWeight: 600,
                    background: c.bordereau === 'Generated' ? '#dcfce7' : '#fef3c7',
                    color: c.bordereau === 'Generated' ? '#15803d' : '#92400e',
                  }}
                >
                  {bordereauLabel(c.bordereau)}
                </span>
              </td>
            )}
            <td style={{ padding: '13px 14px' }}>
              <StatusBadge status={c.status} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
